@use '../../scss/global' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: inline-block;

  .fluid-image {
    padding: 5px 5px 0 5px;
    background-color: $liberty-gray-4;
    border: 1px solid darken($liberty-gray-4, 5%);
    border-radius: 3px;
    display: block;
    margin: 0 auto;
    position: relative;

    .zoom-icon {
      background-color: #ffffff96;
      padding: 3px 10px;
      border-radius: 3px;
      position: absolute;
      bottom: 2px;
      right: 2px;

      &:hover {
        cursor: pointer;
        background-color: white;
      }
    }

    &.no-container {
      background-color: transparent;
      border: none;
      padding: 0;
    }

    .image {
      width: 100%;

      &.hidden {
        display: none;
      }
    }

    .image-error {
      width: 100%;
      height: 300px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }

  }
}